/* eslint-disable import/order */
import type { FC } from 'react';
import { DropDown, DropDownItem } from 'components/Dropdown';
import { Box, H4, Input } from '@deity-io/portal-ui';
import SchemaView from 'components/SchemaEditor/SchemaView';
import type { IDefinitionItem } from '@deity-io/di-data-definitions';

interface IEditProcessor {
  locked?: boolean;
  availableProcessors: string[];
  processorProperties: {};
  owner?: any;
  title?: string;
  configPath?: string[];
  schema?: IDefinitionItem;
  onChange?: (path: Array<string>, value: any) => void;
  onToggleChecked?: (path: Array<string>, checked: boolean) => void;
  checkedPaths?: Array<string>;
  processor?: string;
  expression?: string;
}
const EditProcessor: FC<IEditProcessor> = ({
  locked,
  schema,
  availableProcessors,
  processorProperties,
  owner,
  onChange,
  onToggleChecked,
  title = 'Processors',
  configPath = ['processors'],
  checkedPaths,
  processor,
  expression
}) => {
  // const [checkedPaths, setCheckedPaths] = useState<Array<string>>(['/']);
  const processors = [''];

  // const onToggleChecked = (path: Array<string>, checked: boolean) => {
  //   const pathStr = `/${path.join('/')}`;
  //   let newPaths: Array<string> | undefined;
  //   if (checked) {
  //     const found = checkedPaths.find(item => item === pathStr);
  //     if (!found) {
  //       newPaths = [...checkedPaths, pathStr];
  //     }
  //   } else if (pathStr !== '/') {
  //     newPaths = checkedPaths.filter(item => {
  //       return item !== pathStr;
  //     });
  //   }
  //   if (newPaths) {
  //     // console.log('onToggleChecked', newPaths);
  //     setCheckedPaths(newPaths);
  //   }
  // };
  return (
    <Box sx={{ minHeight: '400px' }}>
      <H4 key="title">Processor</H4>
      <DropDown
        key="select"
        defaultValue={processor || 'toString'}
        placeholder="Select"
        onChange={value => {
          if (onChange) {
            onChange(['type'], value.target?.value);
          }
        }}
      >
        {availableProcessors?.map(availableProcessor => (
          <DropDownItem value={availableProcessor} key={availableProcessor}>
            <H4 style={{ textTransform: 'capitalize' }}>{availableProcessor}</H4>
          </DropDownItem>
        ))}
      </DropDown>
      <H4 key="exTitle">Expression</H4>
      <Input
        fullWidth
        type="text"
        value={expression || ''}
        onChange={value => {
          if (onChange) {
            onChange(['expression'], value.target?.value);
          }
        }}
      />
      <H4 key="schemaTitle">Data available in value</H4>
      <SchemaView
        key="schema"
        field={schema?.key || 'Schema'}
        schema={schema?.toJSON()}
        onToggleChecked={onToggleChecked}
        checkedFields={checkedPaths}
      />
    </Box>
  );
};

export default EditProcessor;
